export default __webpack_public_path__ + "static/media/about-fee.14838e26.svg";